

// import { useCallback, useMemo, useRef, useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { toast } from 'react-toastify';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
// 	Box,
// 	Flex,
// 	HStack,
// 	VStack,
// 	Text,
// 	Badge,
// 	Button,
// 	IconButton,
// 	Icon,
// 	Tooltip,
// 	useBreakpointValue,
// } from '@chakra-ui/react';
// import { FiCheck, FiX } from 'react-icons/fi';

// import {
// 	removeFreshLeadPool,
// 	clearAllLeadPoolFreshLeads,
// } from '../../../../redux/freshLeadPoolSlice';
// import { useCreateItemMutation } from 'api/apiSlice';
// import useUserSession from 'hooks/useUserSession';
// import { useTierCountdown } from '../useTierCountdown';
// import { playNewLeadNotification } from '../leadNotificationUtil';
// import { getLeadValue, getInitials } from './leadFields';
// import LeadDetailsModal from './LeadDetailsModal';
// import { useLeadStatuses } from 'hooks/leads/useLeadStatuses';

// const MotionBox = motion(Box);

// const selectPoolLeads = (state) => state.freshLeadPool?.leads ?? [];

// /* -------------------------------------------------------------------------- */
// /* Per‑item wrapper – owns the expiry countdown                              */
// /* -------------------------------------------------------------------------- */
// const BarItem = ({ lead, isSubmitting, onApprove, onReject, onView, onExpire }) => {
// 	const { remaining, percentage } = useTierCountdown(lead?.expiresAt, onExpire, lead?._id);

// 	const { leadStatuses } = useLeadStatuses();


// 	const leadName = getLeadValue(lead, 'leadName') || 'New Lead';
// 	const agentName = lead?.agentName || getLeadValue(lead, 'agentName');
// 	const selectedOption = leadStatuses?.find(
// 		(item) => item.value === lead?.eLeadStatus,
// 	);

// 	const mainStatus = selectedOption?.label || 'New';

// 	console.log({ mainStatus })

// 	const lowTime = remaining > 0 && remaining <= 10;

// 	const shared = {
// 		lead,
// 		leadName,
// 		mainStatus,
// 		agentName,
// 		remaining,
// 		percentage,
// 		lowTime,
// 		isSubmitting,
// 		onApprove: () => onApprove(lead._id, 'approve'),
// 		onReject: () => onReject(lead._id, 'reject'),
// 		onView: () => onView(lead),
// 	};

// 	return (
// 		<MotionBox
// 			layout
// 			initial={{ opacity: 0, scale: 0.9, x: 12 }}
// 			animate={{ opacity: 1, scale: 1, x: 0 }}
// 			exit={{ opacity: 0, scale: 0.9, x: -12 }}
// 			transition={{ duration: 0.2 }}
// 			flexShrink={0}
// 		>
// 			<GlassItem {...shared} />
// 		</MotionBox>
// 	);
// };

// /* ------------------------------- Action buttons (approve / reject only) --- */
// const ActionButtons = ({ size = 'sm', onApprove, onReject, isSubmitting }) => {
// 	const handleApprove = (e) => { e.stopPropagation(); onApprove(); };
// 	const handleReject = (e) => { e.stopPropagation(); onReject(); };

// 	return (
// 		<HStack spacing={1.5} onClick={(e) => e.stopPropagation()}>
// 			<Tooltip label="Approve" hasArrow openDelay={300}>
// 				<IconButton
// 					aria-label="Approve lead"
// 					icon={<Icon as={FiCheck} />}
// 					size={size}
// 					bg="green.500"
// 					color="text.primary"
// 					_hover={{ bg: 'green.600', transform: 'scale(1.05)' }}
// 					_active={{ bg: 'green.700', transform: 'scale(0.95)' }}
// 					borderRadius="lg"
// 					onClick={handleApprove}
// 					isDisabled={isSubmitting}
// 					boxShadow="0 2px 8px rgba(72,187,120,0.3)"
// 				/>
// 			</Tooltip>
// 			<Tooltip label="Reject" hasArrow openDelay={300}>
// 				<IconButton
// 					aria-label="Reject lead"
// 					icon={<Icon as={FiX} />}
// 					size={size}
// 					bg="red.500"
// 					color="text.primary"
// 					_hover={{ bg: 'red.600', transform: 'scale(1.05)' }}
// 					_active={{ bg: 'red.700', transform: 'scale(0.95)' }}
// 					borderRadius="lg"
// 					onClick={handleReject}
// 					isDisabled={isSubmitting}
// 					boxShadow="0 2px 8px rgba(245,101,101,0.3)"
// 				/>
// 			</Tooltip>
// 		</HStack>
// 	);
// };

// /* ------------------------------ GlassItem – clickable card ---------------- */
// const GlassItem = ({
// 	leadName,
// 	mainStatus,
// 	agentName,
// 	lowTime,
// 	remaining,
// 	onApprove,
// 	onReject,
// 	onView,
// 	isSubmitting,
// }) => {
// 	const buttonSize = useBreakpointValue({ base: 'xs', md: 'sm' });

// 	return (
// 		<HStack
// 			spacing={3}
// 			bg="bg.surface"
// 			borderWidth="1px"
// 			borderColor={lowTime ? 'red.100' : 'green.100'}
// 			borderRadius="sm"
// 			px={{ base: 3, md: 4 }}
// 			py={{ base: 2, md: 2.5 }}
// 			minW={{ base: '280px', md: '300px' }}
// 			maxW={{ base: '380px', md: '420px' }}
// 			boxShadow="0 2px 8px rgba(0,0,0,0.04)"
// 			transition="all 0.2s"
// 			cursor="pointer"
// 			_hover={{
// 				transform: 'translateY(-2px)',
// 				boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
// 				borderColor: 'green.400',
// 			}}
// 			_active={{ transform: 'scale(0.98)' }}
// 			onClick={onView}
// 			role="button"
// 			tabIndex={0}
// 			onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onView(); }}
// 		>
// 			{/* Expiry indicator (thin bar) */}
// 			<Box
// 				position="absolute"
// 				bottom="0"
// 				left="0"
// 				right="0"
// 				h="3px"
// 				bg={lowTime ? 'red.400' : 'green.400'}
// 				borderRadius="0 0 2xl 2xl"
// 				transition="width 0.5s"
// 				width={`${Math.min(100, (remaining / 60) * 100)}%`}
// 				opacity={0.7}
// 			/>

// 			<VStack align="start" spacing={0} flex={1} minW={0}>
// 				<HStack spacing={2} w="full">
// 					<Text
// 						fontWeight="bold"
// 						color="text.primary"
// 						fontSize={{ base: 'sm', md: 'md' }}
// 						noOfLines={1}
// 					>
// 						{leadName}
// 					</Text>
// 					<Badge
// 						colorScheme="gold"
// 						variant='outline'
// 						size="xs"
// 						fontSize="xs"
// 						borderRadius="full"
// 						px={2}
// 						flexShrink={0}
// 						textTransform="capitalize"
// 						letterSpacing="wider"
// 					>
// 						{mainStatus}
// 					</Badge>
// 				</HStack>
// 				<Text fontSize="xs" color="gray.500" _dark={{ color: 'gray.400' }} noOfLines={1}>
// 					Requested by <b>{agentName || 'Agent'}</b>
// 				</Text>
// 			</VStack>

// 			{/* Live dot */}
// 			{/* {remaining > 0 && (
// 				<Box
// 					w="8px"
// 					h="8px"
// 					borderRadius="full"
// 					bg={lowTime ? 'red.400' : 'green.400'}
// 					flexShrink={0}
// 					boxShadow={lowTime ? '0 0 12px rgba(255,0,0,0.6)' : '0 0 12px rgba(0,255,0,0.4)'}
// 					animation={lowTime ? 'pulse 1s infinite' : 'none'}
// 				/>
// 			)} */}

// 			<ActionButtons
// 				size={buttonSize}
// 				onApprove={onApprove}
// 				onReject={onReject}
// 				isSubmitting={isSubmitting}
// 			/>
// 		</HStack>
// 	);
// };

// /* -------------------------------------------------------------------------- */
// /* Main bar                                                                   */
// /* -------------------------------------------------------------------------- */
// const FreshLeadApprovalBar = () => {
// 	const dispatch = useDispatch();
// 	const { userRoleName, isSuperAdmin } = useUserSession();

// 	const leads = useSelector(selectPoolLeads);
// 	const [createItem, { isLoading: isSubmitting }] = useCreateItemMutation();

// 	const [selectedLead, setSelectedLead] = useState(null);

// 	const prevCountRef = useRef(leads.length);
// 	useEffect(() => {
// 		if (leads.length > prevCountRef.current) {
// 			playNewLeadNotification();
// 		}
// 		prevCountRef.current = leads.length;
// 	}, [leads.length]);

// 	const isAdmin = isSuperAdmin || ['Admin', 'superAdmin'].includes(userRoleName);

// 	const handleDecision = useCallback(
// 		async (leadId, action) => {
// 			try {
// 				await createItem({
// 					path: `/adminApproval/real-time/response/${leadId}`,
// 					body: { action },
// 				}).unwrap();
// 				toast.success(
// 					`Lead ${action === 'approve' ? 'Approved' : 'Rejected'} successfully!`,
// 				);
// 			} catch (err) {
// 				console.log(err);
// 				toast.error(err?.data?.message || 'Something went wrong');
// 			} finally {
// 				dispatch(removeFreshLeadPool(leadId));
// 			}
// 		},
// 		[createItem, dispatch],
// 	);

// 	const handleExpire = useCallback(
// 		(leadId) => {
// 			dispatch(removeFreshLeadPool(leadId));
// 		},
// 		[dispatch],
// 	);

// 	const handleClearAll = useCallback(() => {
// 		dispatch(clearAllLeadPoolFreshLeads());
// 		toast.info('All lead requests cleared');
// 	}, [dispatch]);

// 	const count = leads.length;
// 	const hasLeads = count > 0;

// 	const liveSelectedLead = useMemo(
// 		() => (selectedLead ? leads.find((l) => l._id === selectedLead._id) : null),
// 		[selectedLead, leads],
// 	);
// 	useEffect(() => {
// 		if (selectedLead && !liveSelectedLead) setSelectedLead(null);
// 	}, [selectedLead, liveSelectedLead]);

// 	if (!isAdmin || !hasLeads) return null;

// 	return (
// 		<>
// 			<Box w="full" mb={6} px={{ base: 2, md: 0 }}>
// 				<Flex
// 					direction={{ base: 'column', md: 'row' }}
// 					align={{ base: 'stretch', md: 'center' }}
// 					gap={4}
// 					bg="bg.surface"
// 					_dark={{ bg: 'bg.surface' }}
// 					borderWidth="1px"
// 					borderColor="green.200"
// 					borderRadius="2xl"
// 					boxShadow="0 4px 20px rgba(0,0,0,0.04)"
// 					px={{ base: 4, md: 6 }}
// 					py={{ base: 3, md: 3 }}
// 					position="relative"
// 					overflow="hidden"
// 				>
// 					{/* Gold accent rail */}
// 					<Box
// 						position="absolute"
// 						left={0}
// 						top={0}
// 						bottom={0}
// 						w="5px"
// 						bg="linear-gradient(180deg, #F6AD55, #ED8936)"
// 						borderRadius="0 4px 4px 0"
// 					/>

// 					{/* Header */}
// 					<HStack spacing={4} flexShrink={0} pl={2}>
// 						<Box position="relative" display="inline-flex">
// 							<Box w="12px" h="12px" borderRadius="full" bg="green.500" />
// 							<Box
// 								position="absolute"
// 								inset="-4px"
// 								borderRadius="full"
// 								borderWidth="2px"
// 								borderColor="green.500"
// 								opacity={0.4}
// 								sx={{
// 									animation: 'flpulse 1.6s ease-out infinite',
// 									'@keyframes flpulse': {
// 										'0%': { transform: 'scale(0.8)', opacity: 0.5 },
// 										'100%': { transform: 'scale(1.6)', opacity: 0 },
// 									},
// 								}}
// 							/>
// 						</Box>
// 						<VStack align="start" spacing={0}>
// 							<HStack spacing={2}>
// 								<Text fontWeight="bold" color="text.primary" _dark={{ color: 'text.primary' }} fontSize="md">
// 									Approvals
// 								</Text>
// 								{/* Fixed badge – now clearly visible */}
// 								<Badge
// 									bg="red.500"
// 									color="text.primary"
// 									borderRadius="full"
// 									fontSize="xs"
// 									minW="22px"
// 									textAlign="center"
// 									boxShadow="0 2px 8px rgba(245,101,101,0.3)"
// 									_dark={{ bg: 'red.600' }}
// 								>
// 									{count}
// 								</Badge>
// 							</HStack>
// 							<Text fontSize="2xs" color="gray.500" _dark={{ color: 'gray.400' }} lineHeight="1.2">
// 								Live requests
// 							</Text>
// 						</VStack>
// 					</HStack>

// 					{/* Divider (desktop) */}
// 					<Box display={{ base: 'none', md: 'block' }} w="1px" alignSelf="stretch" bg="gray.200" _dark={{ bg: 'bg.elevated' }} />

// 					{/* Scrollable lead row */}
// 					<HStack
// 						flex={1}
// 						spacing={3}
// 						overflowX="auto"
// 						py={1}
// 						align="center"
// 						sx={{
// 							scrollbarWidth: 'thin',
// 							'&::-webkit-scrollbar': { height: '6px' },
// 							'&::-webkit-scrollbar-thumb': {
// 								background: 'rgba(0,0,0,0.15)',
// 								borderRadius: '3px',
// 							},
// 							'&::-webkit-scrollbar-track': {
// 								background: 'rgba(0,0,0,0.03)',
// 							},
// 						}}
// 					>
// 						<AnimatePresence initial={false}>
// 							{leads.map((lead) => (
// 								<BarItem
// 									key={lead._id}
// 									lead={lead}
// 									isSubmitting={isSubmitting}
// 									onApprove={handleDecision}
// 									onReject={handleDecision}
// 									onView={setSelectedLead}
// 									onExpire={handleExpire}
// 								/>
// 							))}
// 						</AnimatePresence>
// 					</HStack>

// 					{/* Right controls */}
// 					<HStack spacing={2} flexShrink={0} justify={{ base: 'space-between', md: 'flex-end' }}>
// 						<Button
// 							size="xs"
// 							variant="ghost"
// 							colorScheme="red"
// 							fontSize="xs"
// 							leftIcon={<Icon as={FiX} />}
// 							borderRadius="lg"
// 							onClick={handleClearAll}
// 							isDisabled={isSubmitting}
// 							_hover={{ bg: 'red.50', _dark: { bg: 'red.900' } }}
// 						>
// 							Clear all
// 						</Button>
// 					</HStack>
// 				</Flex>
// 			</Box>

// 			<LeadDetailsModal
// 				lead={liveSelectedLead}
// 				isOpen={Boolean(liveSelectedLead)}
// 				onClose={() => setSelectedLead(null)}
// 				onDecision={handleDecision}
// 				isSubmitting={isSubmitting}
// 			/>
// 		</>
// 	);
// };

// export default FreshLeadApprovalBar;

import { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import {
	Box,
	Flex,
	HStack,
	VStack,
	Text,
	Badge,
	Button,
	IconButton,
	Icon,
	Tooltip,
	useBreakpointValue,
} from '@chakra-ui/react';
import { FiCheck, FiX, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import {
	removeFreshLeadPool,
	clearAllLeadPoolFreshLeads,
} from '../../../../redux/freshLeadPoolSlice';
import { useCreateItemMutation } from 'api/apiSlice';
import useUserSession from 'hooks/useUserSession';
import { useTierCountdown } from '../useTierCountdown';
import { playNewLeadNotification } from '../leadNotificationUtil';
import { getLeadValue, getInitials } from './leadFields';
import LeadDetailsModal from './LeadDetailsModal';
import { useLeadStatuses } from 'hooks/leads/useLeadStatuses';

const MotionBox = motion(Box);

const selectPoolLeads = (state) => state.freshLeadPool?.leads ?? [];

/* -------------------------------------------------------------------------- */
/* Per‑item wrapper – owns the expiry countdown                              */
/* -------------------------------------------------------------------------- */
const BarItem = ({ lead, isSubmitting, onApprove, onReject, onView, onExpire }) => {
	const { remaining, percentage } = useTierCountdown(lead?.expiresAt, onExpire, lead?._id);

	const { leadStatuses } = useLeadStatuses();

	const leadName = getLeadValue(lead, 'leadName') || 'New Lead';
	const agentName = lead?.agentName || getLeadValue(lead, 'agentName');
	const selectedOption = leadStatuses?.find(
		(item) => item.value === lead?.eLeadStatus,
	);

	const mainStatus = selectedOption?.label || 'New';

	const lowTime = remaining > 0 && remaining <= 10;

	const shared = {
		lead,
		leadName,
		mainStatus,
		agentName,
		remaining,
		percentage,
		lowTime,
		isSubmitting,
		onApprove: () => onApprove(lead._id, 'approve'),
		onReject: () => onReject(lead._id, 'reject'),
		onView: () => onView(lead),
	};

	return (
		<MotionBox
			layout
			initial={{ opacity: 0, scale: 0.9, x: 12 }}
			animate={{ opacity: 1, scale: 1, x: 0 }}
			exit={{ opacity: 0, scale: 0.9, x: -12 }}
			transition={{ duration: 0.2 }}
			flexShrink={0}
		>
			<GlassItem {...shared} />
		</MotionBox>
	);
};

/* ------------------------------- Action buttons (approve / reject only) --- */
const ActionButtons = ({ size = 'sm', onApprove, onReject, isSubmitting }) => {
	const handleApprove = (e) => { e.stopPropagation(); onApprove(); };
	const handleReject = (e) => { e.stopPropagation(); onReject(); };

	return (
		<HStack spacing={1.5} onClick={(e) => e.stopPropagation()}>
			<Tooltip label="Approve" hasArrow openDelay={300}>
				<IconButton
					aria-label="Approve lead"
					icon={<Icon as={FiCheck} />}
					size={size}
					bg="success.subtle"
					color="green.400"
					_hover={{
						bg: 'success.subtle',
						transform: 'scale(1.05)',
						color: 'green.400',
					}}
					_active={{ transform: 'scale(0.95)' }}
					borderRadius="lg"
					border="1px solid"
					borderColor="success"
					onClick={handleApprove}
					isDisabled={isSubmitting}
				/>
			</Tooltip>
			<Tooltip label="Reject" hasArrow openDelay={300}>
				<IconButton
					aria-label="Reject lead"
					icon={<Icon as={FiX} />}
					size={size}
					bg="danger.subtle"
					color="red.400"
					_hover={{
						bg: 'danger.subtle',
						transform: 'scale(1.05)',
						color: 'red.400',
					}}
					_active={{ transform: 'scale(0.95)' }}
					borderRadius="lg"
					border="1px solid"
					borderColor="danger"
					onClick={handleReject}
					isDisabled={isSubmitting}
				/>
			</Tooltip>
		</HStack>
	);
};

/* ------------------------------ GlassItem – clickable card ---------------- */
const GlassItem = ({
	leadName,
	mainStatus,
	agentName,
	lowTime,
	remaining,
	onApprove,
	onReject,
	onView,
	isSubmitting,
}) => {
	const buttonSize = useBreakpointValue({ base: 'xs', md: 'sm' });

	return (
		<HStack
			spacing={3}
			bg="bg.surface"
			borderWidth="1px"
			borderColor={lowTime ? 'danger' : 'border.gold'}
			borderRadius="lg"
			px={{ base: 3, md: 4 }}
			py={{ base: 2, md: 2.5 }}
			minW={{ base: '280px', md: '300px' }}
			maxW={{ base: '380px', md: '420px' }}
			boxShadow="card"
			transition="all 0.2s"
			cursor="pointer"
			position="relative"
			overflow="hidden"
			_hover={{
				transform: 'translateY(-2px)',
				boxShadow: 'goldGlow',
				borderColor: 'gold.primary',
			}}
			_active={{ transform: 'scale(0.98)' }}
			onClick={onView}
			role="button"
			tabIndex={0}
			onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onView(); }}
		>
			{/* Gold accent bar at bottom */}
			<Box
				position="absolute"
				bottom="0"
				left="0"
				right="0"
				h="2px"
				bgGradient={lowTime
					? 'linear-gradient(90deg, #F56565, #E53E3E)'
					: 'linear-gradient(90deg, var(--chakra-colors-accent-gold), var(--chakra-colors-accent-goldLight), var(--chakra-colors-accent-gold))'
				}
				borderRadius="0 0 lg lg"
				opacity={0.8}
			/>

			{/* Gold accent bar at top (subtle) */}
			<Box
				position="absolute"
				top="0"
				left="0"
				right="0"
				h="2px"
				bgGradient={lowTime
					? 'linear-gradient(90deg, #F56565, #E53E3E)'
					: 'linear-gradient(90deg, var(--chakra-colors-accent-gold), var(--chakra-colors-accent-goldLight), var(--chakra-colors-accent-gold))'
				}
				opacity={0.4}
			/>

			<VStack align="start" spacing={0} flex={1} minW={0}>
				<HStack spacing={2} w="full">
					<Text
						fontWeight="bold"
						color="text.heading"
						fontSize={{ base: 'sm', md: 'md' }}
						noOfLines={1}
					>
						{leadName}
					</Text>
					<Badge
						variant="gold"
						size="xs"
						fontSize="10px"
						borderRadius="full"
						px={2}
						flexShrink={0}
						textTransform="capitalize"
						letterSpacing="wider"
					>
						{mainStatus}
					</Badge>
					{lowTime && (
						<Badge
							variant="subtle"
							fontSize="9px"
							borderRadius="full"
							px={1.5}
							color="red.400"
							bg="danger.subtle"
							flexShrink={0}
						>
							⏳ {remaining}s
						</Badge>
					)}
				</HStack>
				<Text fontSize="xs" color="text.muted" noOfLines={1}>
					Requested by <b style={{ color: 'var(--chakra-colors-gold-primary)' }}>{agentName || 'Agent'}</b>
				</Text>
			</VStack>

			<ActionButtons
				size={buttonSize}
				onApprove={onApprove}
				onReject={onReject}
				isSubmitting={isSubmitting}
			/>
		</HStack>
	);
};

/* -------------------------------------------------------------------------- */
/* Main bar                                                                   */
/* -------------------------------------------------------------------------- */
const FreshLeadApprovalBar = () => {
	const dispatch = useDispatch();
	const { userRoleName, isSuperAdmin } = useUserSession();

	const leads = useSelector(selectPoolLeads);
	const [createItem, { isLoading: isSubmitting }] = useCreateItemMutation();

	const [selectedLead, setSelectedLead] = useState(null);
	const [showLeftArrow, setShowLeftArrow] = useState(false);
	const [showRightArrow, setShowRightArrow] = useState(true);

	const scrollContainerRef = useRef(null);
	const prevCountRef = useRef(leads.length);

	useEffect(() => {
		if (leads.length > prevCountRef.current) {
			playNewLeadNotification();
		}
		prevCountRef.current = leads.length;
	}, [leads.length]);

	const isAdmin = isSuperAdmin || ['Admin', 'superAdmin'].includes(userRoleName);

	const handleDecision = useCallback(
		async (leadId, action) => {
			try {
				await createItem({
					path: `/adminApproval/real-time/response/${leadId}`,
					body: { action },
				}).unwrap();
				toast.success(
					`Lead ${action === 'approve' ? 'Approved' : 'Rejected'} successfully!`,
				);
			} catch (err) {
				console.log(err);
				toast.error(err?.data?.message || 'Something went wrong');
			} finally {
				dispatch(removeFreshLeadPool(leadId));
			}
		},
		[createItem, dispatch],
	);

	const handleExpire = useCallback(
		(leadId) => {
			dispatch(removeFreshLeadPool(leadId));
		},
		[dispatch],
	);

	const handleClearAll = useCallback(() => {
		dispatch(clearAllLeadPoolFreshLeads());
		toast.info('All lead requests cleared');
	}, [dispatch]);

	const count = leads.length;
	const hasLeads = count > 0;

	const liveSelectedLead = useMemo(
		() => (selectedLead ? leads.find((l) => l._id === selectedLead._id) : null),
		[selectedLead, leads],
	);
	useEffect(() => {
		if (selectedLead && !liveSelectedLead) setSelectedLead(null);
	}, [selectedLead, liveSelectedLead]);

	// Recalculate which nav arrows to show based on the scroll position vs.
	// the actual content width. Runs on scroll, on mount, when the number of
	// leads changes, and on window resize so the arrows always match reality.
	const updateArrows = useCallback(() => {
		const el = scrollContainerRef.current;
		if (!el) return;
		const { scrollLeft, scrollWidth, clientWidth } = el;
		const overflows = scrollWidth > clientWidth + 1;
		setShowLeftArrow(overflows && scrollLeft > 1);
		setShowRightArrow(overflows && scrollLeft + clientWidth < scrollWidth - 1);
	}, []);

	useEffect(() => {
		updateArrows();
		window.addEventListener('resize', updateArrows);
		return () => window.removeEventListener('resize', updateArrows);
	}, [updateArrows, count]);

	// Scroll functions with smooth behavior
	const scrollLeft = () => {
		scrollContainerRef.current?.scrollBy({ left: -300, behavior: 'smooth' });
	};

	const scrollRight = () => {
		scrollContainerRef.current?.scrollBy({ left: 300, behavior: 'smooth' });
	};

	if (!isAdmin || !hasLeads) return null;

	return (
		<>
			<Box w="full" mb={6} px={{ base: 2, md: 0 }}>
				<Flex
					direction={{ base: 'column', md: 'row' }}
					align={{ base: 'stretch', md: 'center' }}
					gap={4}
					bg="bg.surface"
					borderWidth="1px"
					borderColor="border.default"
					borderRadius="xl"
					boxShadow="card"
					px={{ base: 4, md: 6 }}
					py={{ base: 3, md: 3 }}
					position="relative"
					overflow="hidden"
					_hover={{
						'& .nav-arrow': {
							opacity: 1,
						},
					}}
				>
					{/* Gold accent rail */}
					<Box
						position="absolute"
						left={0}
						top={0}
						bottom={0}
						w="4px"
						bgGradient="linear-gradient(180deg, var(--chakra-colors-accent-gold), var(--chakra-colors-accent-goldLight), var(--chakra-colors-accent-gold))"
						borderRadius="0 4px 4px 0"
					/>

					{/* Header */}
					<HStack spacing={4} flexShrink={0} pl={2}>
						<Box position="relative" display="inline-flex">
							<Box w="10px" h="10px" borderRadius="full" bg="gold.primary" />
							<Box
								position="absolute"
								inset="-3px"
								borderRadius="full"
								borderWidth="2px"
								borderColor="green.200"
								opacity={0.4}
								sx={{
									animation: 'flpulse 1.6s ease-out infinite',
									'@keyframes flpulse': {
										'0%': { transform: 'scale(0.8)', opacity: 0.5 },
										'100%': { transform: 'scale(1.8)', opacity: 0 },
									},
								}}
							/>
						</Box>
						<VStack align="start" spacing={0}>
							<HStack spacing={2}>
								<Text fontWeight="bold" color="text.heading" fontSize="md">
									Approvals
								</Text>
								<Badge
									variant="gold"
									borderRadius="full"
									fontSize="10px"
									minW="22px"
									textAlign="center"
									px={2}
									py={0.5}
								>
									{count}
								</Badge>
							</HStack>
							<Text fontSize="2xs" color="text.muted" lineHeight="1.2">
								Live requests
							</Text>
						</VStack>
					</HStack>

					{/* Divider (desktop) */}
					<Box
						display={{ base: 'none', md: 'block' }}
						w="1px"
						alignSelf="stretch"
						bg="border.subtle"
					/>

					{/* Scrollable lead row with navigation arrows */}
					<Box position="relative" flex={1} overflow="hidden">
						{/* Left Arrow */}
						{showLeftArrow && (
							<IconButton
								className="nav-arrow"
								icon={<FiChevronLeft />}
								aria-label="Scroll left"
								size="sm"
								position="absolute"
								left={0}
								top="50%"
								transform="translateY(-50%)"
								zIndex={2}
								bg="bg.elevated"
								color="text.primary"
								borderRadius="full"
								_hover={{
									bg: 'rgba(255, 149, 0, 0.9)',
									transform: 'translateY(-50%) scale(1.05)',
								}}
								onClick={scrollLeft}
								opacity={{ base: 1, md: 0 }}
								transition="opacity 0.3s ease"
								boxShadow="md"
								backdropFilter="blur(8px)"
							/>
						)}

						{/* Right Arrow */}
						{showRightArrow && (
							<IconButton
								className="nav-arrow"
								icon={<FiChevronRight />}
								aria-label="Scroll right"
								size="sm"
								position="absolute"
								right={0}
								top="50%"
								transform="translateY(-50%)"
								zIndex={2}
								bg="bg.elevated"
								color="text.primary"
								borderRadius="full"
								_hover={{
									bg: 'rgba(255, 149, 0, 0.9)',
									transform: 'translateY(-50%) scale(1.05)',
								}}
								onClick={scrollRight}
								opacity={{ base: 1, md: 0 }}
								transition="opacity 0.3s ease"
								boxShadow="md"
								backdropFilter="blur(8px)"
							/>
						)}

						{/* Scrollable container */}
						<HStack
							ref={scrollContainerRef}
							onScroll={updateArrows}
							flex={1}
							spacing={3}
							overflowX="auto"
							overflowY="hidden"
							scrollBehavior="smooth"
							py={1}
							align="center"
							px={{ base: 2, md: 0 }}
							sx={{
								WebkitOverflowScrolling: 'touch',
								scrollbarWidth: 'none',
								msOverflowStyle: 'none',
								'&::-webkit-scrollbar': { display: 'none' },
							}}
						>
							<AnimatePresence initial={false}>
								{leads.map((lead) => (
									<BarItem
										key={lead._id}
										lead={lead}
										isSubmitting={isSubmitting}
										onApprove={handleDecision}
										onReject={handleDecision}
										onView={setSelectedLead}
										onExpire={handleExpire}
									/>
								))}
							</AnimatePresence>
						</HStack>
					</Box>

					{/* Right controls */}
					<HStack spacing={2} flexShrink={0} justify={{ base: 'space-between', md: 'flex-end' }}>
						<Button
							size="xs"
							variant="ghost"
							fontSize="xs"
							leftIcon={<Icon as={FiX} />}
							borderRadius="lg"
							onClick={handleClearAll}
							isDisabled={isSubmitting}
							color="text.muted"
							_hover={{
								bg: 'danger.subtle',
								color: 'red.400',
							}}
						>
							Clear all
						</Button>
					</HStack>
				</Flex>
			</Box>

			<LeadDetailsModal
				lead={liveSelectedLead}
				isOpen={Boolean(liveSelectedLead)}
				onClose={() => setSelectedLead(null)}
				onDecision={handleDecision}
				isSubmitting={isSubmitting}
			/>
		</>
	);
};

export default FreshLeadApprovalBar;